import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'kt-app-hero-section',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './hero-section.component.html',
  styleUrl: './hero-section.component.scss'
})
export class HeroSectionComponent {

}
